import { observable, runInAction } from 'mobx';
import { useEffect } from 'react';

/**
 * Pages that put their own control in the phone's top-left corner, where `MobileNav`'s floating
 * menu button sits. A page inside another one, like a library inside Libraries, shows a back arrow
 * there instead, as phone apps do: the menu is one step back, on the page it came from.
 */
const corner = observable({ claims: 0 });

export const isMobileNavCornerClaimed = () => corner.claims > 0;

/** Hides the floating menu button while the calling component is mounted. */
export function useClaimMobileNavCorner() {
  useEffect(() => {
    runInAction(() => {
      corner.claims++;
    });
    return () =>
      runInAction(() => {
        corner.claims--;
      });
  }, []);
}
